import { takeLatest, put, call } from 'redux-saga/effects';

import { listTalhaoCadastro } from '../service';
import {
  TABLE_TALHAO_CADASTRO,
  TABLE_TALHAO_CADASTRO_PENDING,
  TABLE_TALHAO_CADASTRO_SUCCESS,
  TABLE_TALHAO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListTalhaoCadastro(action) {
  yield put({ type: TABLE_TALHAO_CADASTRO_PENDING })

  try {
    const table = yield call(listTalhaoCadastro, action.args)
    yield put({ type: TABLE_TALHAO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_TALHAO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListTalhaoCadastro() {
  yield takeLatest(TABLE_TALHAO_CADASTRO, sagaListTalhaoCadastro)
}